export interface IDownloadDocumentOptOut {
    isArchived?: boolean;
    URLToDownload?: string;
    OrderId?: Guid;
}

export class DownloadDocumentOptOut implements IDownloadDocumentOptOut {
    isArchived: boolean = false;
    URLToDownload: string = "";
    OrderId: Guid = null;

    constructor() {

    }
}